import Vue from 'vue'
import Vuesax from 'vuesax'

import 'vuesax/dist/vuesax.css'

Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: '#12B4FF',
      dark: '#10163A'
    }
  }
})
